import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function BeforeAfterTabs() {
  const [activeTab, setActiveTab] = useState<'before' | 'after'>('before');
  const beforeImage = 'https://cdn.magicpatterns.com/uploads/v5YetVWFQpyaUyd3DhRMAv/Before.png';
  const afterImage = 'https://cdn.magicpatterns.com/uploads/hM4v9CY61rDR6itLA3v4HV/After.png';
  return <div className="w-full flex flex-col gap-4" data-id="element-15">
      <div className="w-full bg-white rounded-2xl overflow-hidden flex flex-col" data-id="element-16">
        {/* Tabs Header */}
        <div className="flex border-b border-[#E8E4DF] relative" data-id="element-17">
          <button onClick={() => setActiveTab('before')} className={`flex-1 py-4 text-center text-sm font-bold transition-colors relative z-10 ${activeTab === 'before' ? 'text-[#1A1A1A]' : 'text-[#A09A94] hover:text-[#6B6560]'}`} data-id="element-18">
            Before
          </button>
          <button onClick={() => setActiveTab('after')} className={`flex-1 py-4 text-center text-sm font-bold transition-colors relative z-10 ${activeTab === 'after' ? 'text-[#1A1A1A]' : 'text-[#A09A94] hover:text-[#6B6560]'}`} data-id="element-19">
            After
          </button>

          {/* Animated Indicator */}
          <div className="absolute bottom-0 left-0 w-full h-0.5 flex z-20" data-id="element-20">
            <motion.div className="h-full bg-[#1A1A1A] w-1/2" animate={{
            x: activeTab === 'before' ? '0%' : '100%'
          }} transition={{
            type: 'spring',
            stiffness: 300,
            damping: 30
          }} data-id="element-21" />
          </div>
        </div>

        {/* Content Area */}
        <div className="w-full bg-[#F8F6F3] grid" data-id="element-22">
          <AnimatePresence data-id="element-23">
            {activeTab === 'before' ? <motion.div key="before" initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} exit={{
            opacity: 0
          }} transition={{
            duration: 0.3
          }} className="w-full col-start-1 row-start-1" data-id="element-24">
                <img src={beforeImage} alt="Before" className="w-full h-auto block" data-id="element-25" />
              </motion.div> : <motion.div key="after" initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} exit={{
            opacity: 0
          }} transition={{
            duration: 0.3
          }} className="w-full col-start-1 row-start-1" data-id="element-26">
                <img src={afterImage} alt="After" className="w-full h-auto block" data-id="element-27" />
              </motion.div>}
          </AnimatePresence>
        </div>
      </div>

      <p className="text-sm text-[#A09A94] text-center leading-relaxed px-4" data-id="element-28">
        With the simplification of the checkout, return customers were now able
        to place an order with one click rather than three distinct steps.
      </p>
    </div>;
}